import { SagaIterator } from 'redux-saga'
import { put, call, takeLatest, fork } from 'redux-saga/effects'
import { getSinglePatientAlertData } from './api'
import { GET_SINGLE_PATIENT_ALERT } from './actionTypes'
import {
  errorSinglePatientAlert,
  addSinglePatientAlert,
} from './singlePatientAlertReducer'
import { SinglePatientAlertType } from './types'

type Action = {
  type: string
  payload: string
}

export function* handleGetSinglePatientAlertData(
  actions: Action
): SagaIterator<void> {
  try {
    const response = yield call(getSinglePatientAlertData, actions.payload)
    const { data } = response
    let modifiedData: SinglePatientAlertType = {
      key: actions.payload,
      patientAlertData: data.alerts,
    }

    yield put(addSinglePatientAlert(modifiedData))
  } catch (error: any) {
    yield put(errorSinglePatientAlert(error.response.data.message))
  }
}

export function* watcherSaga() {
  yield takeLatest(GET_SINGLE_PATIENT_ALERT, handleGetSinglePatientAlertData)
}

export const singlePatientAlertSaga = [fork(watcherSaga)]
